<div class="container-fluid new-dash">
  <!-- date filter -->
  <div class="row">
    <div class="col-md-12">
      <div
        class="row mb-4 align-items-end filtersvalue justify-content-center justify-content-md-end mr-0"
      >
        <div class="col-6 col-md-3 px-0">
          <div
            class="form-group position-relative m-0 d-flex align-items-center"
          >
            <label for class="font-weight-normal m-0 w-50">From Date</label>
            <input
              type="date"
              class="form-control"
              autocomplete="off"
              novalidate
            />
          </div>
        </div>

        <div class="col-6 col-md-3 px-0">
          <div
            class="form-group position-relative m-0 d-flex align-items-center"
          >
            <label for class="font-weight-normal m-0 w-50 text-center"
              >To Date</label
            >
            <input type="date" class="form-control mr-0 mr-md-3" />
          </div>
        </div>

        <div class="col-auto px-1 mt-2 mt-md-0">
          <button class="border-0 cross-icon1">
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
        </div>

        <div class="col-auto px-1 mt-2 mt-md-0">
          <button class="border-0 cross-icon1">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col-auto pr-0 mt-2 mt-md-0">
          <button class="btn btn-new-dash">Capture to PDF</button>
        </div>
        <div class="col-12 position-relative"></div>
      </div>
    </div>
  </div>

  <!-- date range for mobile  -->
  <div class="row d-none">
    <div class="col-6">
      <div class="dropdown">
        <div class="col-auto pr-0">
          <button
            class="btn btn-new-dash"
            id="dateRangeButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Date Range
          </button>
          <div
            class="dropdown-menu dropdown-menu-custom"
            aria-labelledby="dateRangeButton"
          >
            <div
              class="row mb-4 align-items-end filtersvalue justify-content-md-end mr-0"
            >
              <div class="col-5 px-0">
                <div
                  class="form-group position-relative m-0 d-flex align-items-center"
                >
                  <label for="fromDate" class="font-weight-normal m-0 w-50"
                    >From Date</label
                  >
                  <input
                    type="date"
                    id="fromDate"
                    class="form-control"
                    autocomplete="off"
                    novalidate
                  />
                </div>
              </div>
              <div class="col-5 px-0">
                <div
                  class="form-group position-relative m-0 d-flex align-items-center"
                >
                  <label
                    for="toDate"
                    class="font-weight-normal m-0 w-50 text-center"
                    >To Date</label
                  >
                  <input type="date" id="toDate" class="form-control mr-3" />
                </div>
              </div>
              <div class="col-auto px-1">
                <button class="border-0 cross-icon1" onclick="applyDateRange()">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-auto px-1">
                <button class="border-0 cross-icon1" onclick="resetDateRange()">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-12 position-relative">
                <small
                  id="dateError"
                  class="text-danger text-center mt-1 position-absolute d-none"
                >
                  Please ensure the From Date is earlier than or equal to the To
                  Date
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <button class="btn btn-new-dash">Capture to PDF</button>
    </div>
  </div>

  <!-- above tiles -->
  <div class="row">
    <div class="col-sm-12 col-lg-4 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Total Registered Member</h6>
          <h4>1247</h4>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-start align-items-center w-75">
            <div class="sub-counter">
              <p>Last Week</p>
              <h6>4</h6>
            </div>
            <div class="sub-counter">
              <p>Last Month</p>
              <h6>4</h6>
            </div>
            <div class="sub-counter">
              <p>Last Year</p>
              <h6>91</h6>
            </div>
          </div>
          <img
            src="../assets/img/icons/member.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-lg-4 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Total Login/Active Member</h6>
          <h4>110</h4>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-start align-items-center w-75">
            <div class="sub-counter">
              <p>Last Week</p>
              <h6>0</h6>
            </div>
            <div class="sub-counter">
              <p>Last Month</p>
              <h6>0</h6>
            </div>
            <div class="sub-counter">
              <p>Last Year</p>
              <h6>39</h6>
            </div>
          </div>
          <img
            src="../assets/img/icons/user.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-lg-4 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Total Community Post Count</h6>
          <h4>750</h4>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-start align-items-center w-75">
            <div class="sub-counter">
              <p>Last Week</p>
              <h6>8</h6>
            </div>
            <div class="sub-counter">
              <p>Last Month</p>
              <h6>21</h6>
            </div>
            <div class="sub-counter">
              <p>Last Year</p>
              <h6>750</h6>
            </div>
          </div>
          <img
            src="../assets/img/icons/post.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- accordion -->
  <div class="row">
    <div class="col-md-12">
      <div id="accordion">
        <div class="card w-100">
          <div class="card-header" id="headingOne">
            <div
              class="accordion-title"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              (click)="toggleAccordion()"
            >
              Registered and Login users By States
            </div>
            <div class="header-actions">
              <span
                class="toggle-icon"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                [ngClass]="{ rotate: isExpanded }"
                (click)="toggleAccordion()"
              >
                <i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
              </span>
              <button class="btn btn-new-dash" style="margin-top: 1px">
                <img
                  src="../assets/img/icons/csv-download-icon.png"
                  class="img-fluid"
                  width="14px"
                  alt="logo"
                />
                Download
              </button>
            </div>
          </div>

          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            <div class="card-body">
              <ng-container>
                <canvas
                  baseChart
                  [datasets]="[
                    {
                      data: [65, 59, 80, 81, 56, 55, 40],
                      label: 'Registered Users'
                    },
                    {
                      data: [28, 48, 40, 19, 86, 27, 90],
                      label: 'Logged In Users'
                    }
                  ]"
                  [labels]="[
                    'State A',
                    'State B',
                    'State C',
                    'State D',
                    'State E',
                    'State F',
                    'State G'
                  ]"
                  [options]="{
                    responsive: true,
                    scales: {
                      xAxes: [{ ticks: { beginAtZero: true } }],
                      yAxes: [{ stacked: false }]
                    },
                    legend: { display: true }
                  }"
                  [plugins]="[]"
                  [legend]="true"
                  [chartType]="'horizontalBar'"
                >
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div id="accordion">
        <div class="card w-100">
          <div class="card-header" id="headingTwo">
            <div
              class="accordion-title"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
              (click)="toggleAccordion()"
            >
              Registered Users By Sector of Business
            </div>
            <div class="header-actions">
              <span
                class="toggle-icon"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
                [ngClass]="{ rotate: isExpanded }"
                (click)="toggleAccordion()"
              >
                <i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
              </span>
              <button class="btn btn-new-dash" style="margin-top: 1px">
                <img
                  src="../assets/img/icons/csv-download-icon.png"
                  class="img-fluid"
                  width="14px"
                  alt="logo"
                />
                Download
              </button>
            </div>
          </div>

          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordion"
          >
            <div class="card-body">
              <ng-container>
                <canvas
                  baseChart
                  [datasets]="[
                    {
                      data: [65, 59, 80, 81, 56, 55, 40],
                      label: 'Registered Users'
                    }
                  ]"
                  [labels]="[
                    'State A',
                    'State B',
                    'State C',
                    'State D',
                    'State E',
                    'State F',
                    'State G'
                  ]"
                  [options]="{
                    responsive: true,
                    scales: {
                      xAxes: [{ ticks: { beginAtZero: true } }],
                      yAxes: [{ stacked: false }]
                    },
                    legend: { display: true }
                  }"
                  [plugins]="[]"
                  [legend]="true"
                  [chartType]="'horizontalBar'"
                >
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div id="accordion">
        <div class="card w-100">
          <div class="card-header" id="headingThree">
            <div
              class="accordion-title"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="true"
              aria-controls="collapseThree"
              (click)="toggleAccordion()"
            >
              Registered Users By Area of Interest
            </div>
            <div class="header-actions">
              <span
                class="toggle-icon"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
                [ngClass]="{ rotate: isExpanded }"
                (click)="toggleAccordion()"
              >
                <i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
              </span>
              <button class="btn btn-new-dash" style="margin-top: 1px">
                <img
                  src="../assets/img/icons/csv-download-icon.png"
                  class="img-fluid"
                  width="14px"
                  alt="logo"
                />
                Download
              </button>
            </div>
          </div>

          <div
            id="collapseThree"
            class="collapse show"
            aria-labelledby="headingthree"
            data-parent="#accordion"
          >
            <div class="card-body">
              <ng-container>
                <canvas
                  baseChart
                  [datasets]="[
                    {
                      data: [28, 48, 40, 19, 86, 27, 90],
                      label: 'Logged In Users'
                    }
                  ]"
                  [labels]="[
                    'State A',
                    'State B',
                    'State C',
                    'State D',
                    'State E',
                    'State F',
                    'State G'
                  ]"
                  [options]="{
                    responsive: true,
                    scales: {
                      xAxes: [{ ticks: { beginAtZero: true } }],
                      yAxes: [{ stacked: false }]
                    },
                    legend: { display: true }
                  }"
                  [plugins]="[]"
                  [legend]="true"
                  [chartType]="'horizontalBar'"
                >
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div id="accordion">
        <div class="card w-100">
          <div class="card-header" id="headingFour">
            <div
              class="accordion-title"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="true"
              aria-controls="collapseFour"
              (click)="toggleAccordion()"
            >
              Registered Users By Age
            </div>
            <div class="header-actions">
              <button class="btn btn-new-dash" style="margin-top: 1px">
                <img
                  src="../assets/img/icons/csv-download-icon.png"
                  class="img-fluid"
                  width="14px"
                  alt="logo"
                />
                Download
              </button>
            </div>
          </div>

          <div
            id="collapseFour"
            class="collapse show"
            aria-labelledby="headingFour"
            data-parent="#accordion"
          >
            <div class="card-body">
              <ng-container>
                <canvas
                  baseChart
                  [datasets]="[
                    {
                      data: [65, 59, 80, 81, 56, 55, 40],
                      label: 'Registered Users',
                      backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#4BC0C0',
                        '#9966FF',
                        '#FF9F40',
                        '#C9CBCF'
                      ]
                    }
                  ]"
                  [labels]="[
                    'State A',
                    'State B',
                    'State C',
                    'State D',
                    'State E',
                    'State F',
                    'State G'
                  ]"
                  [options]="{
                    responsive: true,
                    cutoutPercentage: 50,
                    legend: { display: true }
                  }"
                  [plugins]="[]"
                  [legend]="true"
                  [chartType]="'doughnut'"
                >
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div id="accordion">
        <div class="card w-100">
          <div class="card-header" id="headingFive">
            <div
              class="accordion-title"
              data-toggle="collapse"
              data-target="#collapseFive"
              aria-expanded="true"
              aria-controls="collapseFive"
              (click)="toggleAccordion()"
            >
              Page wise total views
            </div>
            <div class="header-actions">
              <button class="btn btn-new-dash" style="margin-top: 1px">
                <img
                  src="../assets/img/icons/csv-download-icon.png"
                  class="img-fluid"
                  width="14px"
                  alt="logo"
                />
                Download
              </button>
            </div>
          </div>

          <div
            id="collapseFive"
            class="collapse show"
            aria-labelledby="headingFive"
            data-parent="#accordion"
          >
            <div class="card-body">
              <ng-container>
                <canvas
                  baseChart
                  [datasets]="[
                    {
                      data: [65, 59, 80, 81, 56, 55, 40],
                      label: 'Registered Users',
                      backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#4BC0C0',
                        '#9966FF',
                        '#FF9F40',
                        '#C9CBCF'
                      ]
                    }
                  ]"
                  [labels]="[
                    'State A',
                    'State B',
                    'State C',
                    'State D',
                    'State E',
                    'State F',
                    'State G'
                  ]"
                  [options]="{
                    responsive: true,
                    cutoutPercentage: 50,
                    legend: { display: true }
                  }"
                  [plugins]="[]"
                  [legend]="true"
                  [chartType]="'doughnut'"
                >
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- below tiles -->
  <div class="row">
    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Active Partner Count</h6>
          <h4>159</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img
            src="../assets/img/icons/partner.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Upcoming Events Count</h6>
          <h4>84</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img
            src="../assets/img/icons/upcoming.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Past Event Count</h6>
          <h4>17</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img
            src="../assets/img/icons/past.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Award To Reward Count</h6>
          <h4>28</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img src="../assets/img/icons/atr.png" class="img-fluid" alt="logo" />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Member Feedback Count</h6>
          <h4>1254</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img
            src="../assets/img/icons/mem-feed.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Member Blogs Count</h6>
          <h4>1247</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img
            src="../assets/img/icons/post.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-lg-3 d-flex">
      <div class="card flex-fill w-100">
        <div class="card-block px-3 pt-3 pb-0">
          <h6>Videos Count</h6>
          <h4>17</h4>
        </div>
        <div class="card-footer">
          <a>View More</a>
          <img
            src="../assets/img/icons/videos.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>
  </div>
</div>
